import type { Card /* CardType */ } from "@apac/checkout";
import { CardType } from "@hsbc/utilities";

export const hsbcCardMap: Record<string, Card> = {
  517745: {
    type: CardType.CreditCard,
    name: "HSBC Advance Credit Card",
    incentives: [],
  },
  552067: {
    type: CardType.CreditCard,
    name: "HSBC World Credit Card",
    incentives: [],
  },
  430599: {
    type: CardType.CreditCard,
    name: "HSBC Visa Platinum Credit Card",
    incentives: [],
  },
  453927: {
    type: CardType.CreditCard,
    name: "HSBC Visa Gold Credit Card",
    incentives: [],
  },
  453928: {
    type: CardType.CreditCard,
    name: "HSBC Visa Signature Credit Card",
    incentives: [],
  },
  428681: {
    type: CardType.DebitCard,
    name: "HSBC Visa Classic Debit Card",
    incentives: [],
  },
  428683: {
    type: CardType.DebitCard,
    name: "HSBC Visa Platinum Debit Card",
    incentives: [],
  },
  428685: {
    type: CardType.DebitCard,
    name: "HSBC Visa Platinum Debit Card",
    incentives: [],
  },
};
